import { defineMessages } from 'react-intl';

export const generalMessages = defineMessages({
    cancel: {
        id: 'cancel',
        defaultMessage: 'Cancel',
    },
    editEntry: {
        id: 'edit-entry',
        defaultMessage: 'Edit {entry}',
    },
    deleteEntry: {
        id: 'delete-entry',
        defaultMessage: 'Delete {entry}',
    },
    createEntry: {
        id: 'create-entry',
        defaultMessage: 'Create {entry}',
    },
    copyEntry: {
        id: 'copy-entry',
        defaultMessage: 'Copy {entry}',
    },
    yes: {
        id: 'yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'no',
        defaultMessage: 'No',
    },
    close: {
        id: 'close',
        defaultMessage: 'Close',
    },
    noValue: {
        id: 'no-value',
        defaultMessage: 'No value',
    },
    edit: {
        id: 'edit',
        defaultMessage: 'Edit',
    },
    delete: {
        id: 'delete',
        defaultMessage: 'Delete',
    },
    next: {
        id: 'next',
        defaultMessage: 'Next',
    },
    previous: {
        id: 'previous',
        defaultMessage: 'Previous',
    },
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    copy: {
        id: 'copy',
        defaultMessage: 'Copy',
    },
    clearSelection: {
        id: 'clear-selection',
        defaultMessage: 'Clear selection',
    },
});
export const generalErrorMessages = defineMessages({
    somethingWentWrong: {
        id: 'something-went-wrong',
        defaultMessage: 'Something went wrong',
    },
    somethingWentWrongRetry: {
        id: 'something-went-wrong-retry',
        defaultMessage: 'Please retry again later or contact an administrator',
    },
    unknownError: {
        id: 'unknown-error',
        defaultMessage: 'An unknown error occurred',
    },
    error: {
        id: 'error',
        defaultMessage: 'Error',
    },
});

export const generalValidationMessages = defineMessages({
    fieldRequired: {
        id: 'field-required',
        defaultMessage: 'This field is required',
    },
    fieldInvalidMinLength: {
        id: 'field-invalid-min-length',
        defaultMessage: 'Minimum field length is {min} symbols',
    },
    fieldInvalidMaxLength: {
        id: 'field-invalid-max-length',
        defaultMessage: 'Maximum field length is {max} symbols',
    },
    fieldInvalidMaxValue: {
        id: 'field-invalid-max-value',
        defaultMessage: 'Maximum field value is {max}',
    },
    fieldRequiredSelect: {
        id: 'field-required-select',
        defaultMessage: 'Please select a value',
    },
    fieldRequiredArray: {
        id: 'field-required-array',
        defaultMessage: 'Please select at least one value',
    },
    fieldRequiredDate: {
        id: 'field-required-date',
        defaultMessage: 'Please select a date',
    },
    fieldInvalidTime: {
        id: 'field-required-time',
        defaultMessage: 'The entered value is not a valid time',
    },
    fieldInvalidEmail: {
        id: 'field-invalid-email',
        defaultMessage: 'The entered value is not a valid email',
    },
    fieldInvalidMinValue: {
        id: 'field-invalid-min-value',
        defaultMessage: 'Minimum field value is {min}',
    },
    fieldInvalidURL: {
        id: 'field-invalid-url',
        defaultMessage: 'The entered value is not a valid URL',
    },
});
